import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SearchFilters = ({ onFilterChange, activeTab }) => {
  const [filters, setFilters] = useState({
    search: '',
    client: '',
    status: '',
    dateRange: '',
    paymentStatus: ''
  });

  const clientOptions = [
    { value: '', label: 'All Clients' },
    { value: 'ajio', label: 'AJIO' },
    { value: 'myntra', label: 'MYNTRA' },
    { value: 'fashion-hub', label: 'Fashion Hub Pvt Ltd' },
    { value: 'style-store', label: 'Style Store' },
    { value: 'trendy-wear', label: 'Trendy Wear Co.' }
  ];

  const invoiceStatusOptions = [
    { value: '', label: 'All Status' },
    { value: 'draft', label: 'Draft' },
    { value: 'sent', label: 'Sent' },
    { value: 'paid', label: 'Paid' },
    { value: 'overdue', label: 'Overdue' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const challanStatusOptions = [
    { value: '', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'dispatched', label: 'Dispatched' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'returned', label: 'Returned' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const paymentStatusOptions = [
    { value: '', label: 'All Payments' },
    { value: 'pending', label: 'Pending' },
    { value: 'partial', label: 'Partial' },
    { value: 'paid', label: 'Paid' },
    { value: 'overdue', label: 'Overdue' }
  ];

  const dateRangeOptions = [
    { value: '', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const clearFilters = () => {
    const clearedFilters = {
      search: '',
      client: '',
      status: '',
      dateRange: '',
      paymentStatus: ''
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
          <Icon name="Filter" size={20} />
          <span>Search & Filters</span>
        </h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={clearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
          >
            Clear All
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <Input
          type="search"
          placeholder={`Search ${activeTab === 'invoices' ? 'invoices' : 'challans'}...`}
          value={filters.search}
          onChange={(e) => handleFilterChange('search', e.target.value)}
          className="w-full"
        />

        <Select
          placeholder="Select Client"
          options={clientOptions}
          value={filters.client}
          onChange={(value) => handleFilterChange('client', value)}
          searchable
        />

        <Select
          placeholder="Status"
          options={activeTab === 'invoices' ? invoiceStatusOptions : challanStatusOptions}
          value={filters.status}
          onChange={(value) => handleFilterChange('status', value)}
        />

        <Select
          placeholder="Date Range"
          options={dateRangeOptions}
          value={filters.dateRange}
          onChange={(value) => handleFilterChange('dateRange', value)}
        />

        {activeTab === 'invoices' && (
          <Select
            placeholder="Payment Status"
            options={paymentStatusOptions}
            value={filters.paymentStatus}
            onChange={(value) => handleFilterChange('paymentStatus', value)}
          />
        )}
      </div>

      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          {filters.search && (
            <div className="flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-md text-sm">
              <span>Search: "{filters.search}"</span>
              <button onClick={() => handleFilterChange('search', '')}>
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {filters.client && (
            <div className="flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-md text-sm">
              <span>Client: {clientOptions.find(opt => opt.value === filters.client)?.label}</span>
              <button onClick={() => handleFilterChange('client', '')}>
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {filters.status && (
            <div className="flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-md text-sm">
              <span>Status: {filters.status}</span>
              <button onClick={() => handleFilterChange('status', '')}>
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchFilters;